import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from './img/barleyWeb/logo2.png';
import _imports_1 from './img/IEnglish/logo2.png';
import _imports_2 from './img/JitaGuest/logo2.png';
import _imports_3 from './img/vehicle/logo2.png';
import _imports_4 from './img/pharmacy/logo2.png';
import _imports_5 from './img/wisdom/logo2.png';
import _imports_6 from './img/uestc/logo2.svg';
import _imports_7 from './img/hinova/logo2.png';
import _imports_8 from './img/haooubo/logo2.png';
import _imports_9 from './img/trustEconomy/logo.png';
import _imports_10 from './img/power/logo.png';
import _imports_11 from './img/liveEra/logo.png';
const _hoisted_1 = {
  class: "success-case-box"
};
const _hoisted_2 = {
  class: "banner-box"
};
const _hoisted_3 = {
  class: "big-title"
};
const _hoisted_4 = {
  class: "custom-case"
};
const _hoisted_5 = {
  class: "all-success-case"
};
const _hoisted_6 = {
  class: "case-list"
};
const _hoisted_7 = {
  class: "case-info"
};
const _hoisted_8 = {
  class: "title"
};
const _hoisted_9 = {
  class: "tag"
};
const _hoisted_10 = {
  class: "tag-item"
};
const _hoisted_11 = {
  class: "tag-item"
};
const _hoisted_12 = {
  class: "tag-item"
};
const _hoisted_13 = {
  class: "tag-item"
};
const _hoisted_14 = {
  class: "case-info"
};
const _hoisted_15 = {
  class: "title"
};
const _hoisted_16 = {
  class: "tag"
};
const _hoisted_17 = {
  class: "tag-item"
};
const _hoisted_18 = {
  class: "tag-item"
};
const _hoisted_19 = {
  class: "tag-item"
};
const _hoisted_20 = {
  class: "tag-item"
};
const _hoisted_21 = {
  class: "case-info"
};
const _hoisted_22 = {
  class: "title"
};
const _hoisted_23 = {
  class: "tag"
};
const _hoisted_24 = {
  class: "tag-item"
};
const _hoisted_25 = {
  class: "tag-item"
};
const _hoisted_26 = {
  class: "case-info"
};
const _hoisted_27 = {
  class: "title"
};
const _hoisted_28 = {
  class: "tag"
};
const _hoisted_29 = {
  class: "tag-item"
};
const _hoisted_30 = {
  class: "tag-item"
};
const _hoisted_31 = {
  class: "case-info"
};
const _hoisted_32 = {
  class: "title"
};
const _hoisted_33 = {
  class: "tag"
};
const _hoisted_34 = {
  class: "tag-item"
};
const _hoisted_35 = {
  class: "tag-item"
};
const _hoisted_36 = {
  class: "tag-item"
};
const _hoisted_37 = {
  class: "case-info"
};
const _hoisted_38 = {
  class: "title"
};
const _hoisted_39 = {
  class: "tag"
};
const _hoisted_40 = {
  class: "tag-item"
};
const _hoisted_41 = {
  class: "tag-item"
};
const _hoisted_42 = {
  class: "tag-item"
};
const _hoisted_43 = {
  class: "tag-item"
};
const _hoisted_44 = {
  class: "case-info"
};
const _hoisted_45 = {
  class: "title"
};
const _hoisted_46 = {
  class: "tag"
};
const _hoisted_47 = {
  class: "tag-item"
};
const _hoisted_48 = {
  class: "tag-item"
};
const _hoisted_49 = {
  class: "case-info"
};
const _hoisted_50 = {
  class: "title"
};
const _hoisted_51 = {
  class: "tag"
};
const _hoisted_52 = {
  class: "tag-item"
};
const _hoisted_53 = {
  class: "tag-item"
};
const _hoisted_54 = {
  class: "tag-item"
};
const _hoisted_55 = {
  class: "tag-item"
};
const _hoisted_56 = {
  class: "case-info"
};
const _hoisted_57 = {
  class: "title"
};
const _hoisted_58 = {
  class: "tag"
};
const _hoisted_59 = {
  class: "tag-item"
};
const _hoisted_60 = {
  class: "tag-item"
};
const _hoisted_61 = {
  class: "case-info"
};
const _hoisted_62 = {
  class: "title"
};
const _hoisted_63 = {
  class: "tag"
};
const _hoisted_64 = {
  class: "tag-item"
};
const _hoisted_65 = {
  class: "tag-item"
};
const _hoisted_66 = {
  class: "case-info"
};
const _hoisted_67 = {
  class: "title"
};
const _hoisted_68 = {
  class: "tag"
};
const _hoisted_69 = {
  class: "tag-item"
};
const _hoisted_70 = {
  class: "tag-item"
};
const _hoisted_71 = {
  class: "case-info"
};
const _hoisted_72 = {
  class: "title"
};
const _hoisted_73 = {
  class: "tag"
};
const _hoisted_74 = {
  class: "tag-item"
};
const _hoisted_75 = {
  class: "tag-item"
};
const _hoisted_76 = {
  class: "bottom-banner"
};
const _hoisted_77 = {
  class: "banner-con"
};
const _hoisted_78 = {
  class: "title"
};
import { ref } from 'vue';
import { useRouter } from 'vue-router';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const router = useRouter();
    const advisoryServiceRef = ref(null);
    const goAdvisory = () => {
      advisoryServiceRef['value'].show();
    };
    const toCasePage = path => {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      router.push(`/successCase/${path}`);
    };
    return (_ctx, _cache) => {
      const _component_AdvisoryService = _resolveComponent("AdvisoryService");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('successCase.text33')), 1), _createElementVNode("span", null, _toDisplayString(_ctx.$t('successCase.text34')), 1)]), _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('successCase.text35')), 1), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
        class: "case-item",
        onClick: _cache[0] || (_cache[0] = $event => toCasePage('barleyWeb'))
      }, [_cache[12] || (_cache[12] = _createElementVNode("div", {
        class: "logo-box"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: ""
      })], -1)), _createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('successCase.text36')), 1), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('successCase.text37')), 1), _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('successCase.text38')), 1), _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('successCase.text39')), 1), _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('successCase.text40')), 1)]), _createElementVNode("span", null, _toDisplayString(_ctx.$t('successCase.text41')) + "...... ", 1)])]), _createElementVNode("div", {
        class: "case-item",
        onClick: _cache[1] || (_cache[1] = $event => toCasePage('IEnglish'))
      }, [_cache[13] || (_cache[13] = _createElementVNode("div", {
        class: "logo-box"
      }, [_createElementVNode("img", {
        src: _imports_1,
        alt: ""
      })], -1)), _createElementVNode("div", _hoisted_14, [_createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('successCase.text42')), 1), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('successCase.text37')), 1), _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('successCase.text38')), 1), _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('successCase.text43')), 1), _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('successCase.text40')), 1)]), _createElementVNode("span", null, _toDisplayString(_ctx.$t('successCase.text44')) + "......", 1)])]), _createElementVNode("div", {
        class: "case-item",
        onClick: _cache[2] || (_cache[2] = $event => toCasePage('JitaGuest'))
      }, [_cache[14] || (_cache[14] = _createElementVNode("div", {
        class: "logo-box"
      }, [_createElementVNode("img", {
        src: _imports_2,
        alt: ""
      })], -1)), _createElementVNode("div", _hoisted_21, [_createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('successCase.text45')), 1), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t('successCase.text37')), 1), _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('successCase.text46')), 1)]), _createElementVNode("span", null, _toDisplayString(_ctx.$t('successCase.text47')) + "......", 1)])]), _createElementVNode("div", {
        class: "case-item",
        onClick: _cache[3] || (_cache[3] = $event => toCasePage('vehicle'))
      }, [_cache[15] || (_cache[15] = _createElementVNode("div", {
        class: "logo-box"
      }, [_createElementVNode("img", {
        src: _imports_3,
        alt: ""
      })], -1)), _createElementVNode("div", _hoisted_26, [_createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t('successCase.text48')), 1), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t('successCase.text49')), 1), _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$t('successCase.text50')), 1)]), _createElementVNode("span", null, _toDisplayString(_ctx.$t('successCase.text51')) + "...... ", 1)])]), _createElementVNode("div", {
        class: "case-item",
        onClick: _cache[4] || (_cache[4] = $event => toCasePage('pharmacy'))
      }, [_cache[16] || (_cache[16] = _createElementVNode("div", {
        class: "logo-box"
      }, [_createElementVNode("img", {
        src: _imports_4,
        alt: ""
      })], -1)), _createElementVNode("div", _hoisted_31, [_createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t('successCase.text52')), 1), _createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.$t('successCase.text50')), 1), _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t('successCase.text53')), 1), _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.$t('successCase.text54')), 1)]), _createElementVNode("span", null, _toDisplayString(_ctx.$t('successCase.text55')) + "...... ", 1)])]), _createElementVNode("div", {
        class: "case-item",
        onClick: _cache[5] || (_cache[5] = $event => toCasePage('wisdom'))
      }, [_cache[17] || (_cache[17] = _createElementVNode("div", {
        class: "logo-box"
      }, [_createElementVNode("img", {
        src: _imports_5,
        alt: ""
      })], -1)), _createElementVNode("div", _hoisted_37, [_createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.$t('successCase.text56')), 1), _createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.$t('successCase.text50')), 1), _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.$t('successCase.text38')), 1), _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.$t('successCase.text57')), 1), _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.$t('successCase.text58')), 1)]), _createElementVNode("span", null, _toDisplayString(_ctx.$t('successCase.text59')) + "...... ", 1)])]), _createElementVNode("div", {
        class: "case-item",
        onClick: _cache[6] || (_cache[6] = $event => toCasePage('uestc'))
      }, [_cache[18] || (_cache[18] = _createElementVNode("div", {
        class: "logo-box"
      }, [_createElementVNode("img", {
        src: _imports_6,
        alt: ""
      })], -1)), _createElementVNode("div", _hoisted_44, [_createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.$t('successCase.text60')), 1), _createElementVNode("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.$t('successCase.text61')), 1), _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.$t('successCase.text62')), 1)]), _createElementVNode("span", null, _toDisplayString(_ctx.$t('successCase.text63')) + "...... ", 1)])]), _createElementVNode("div", {
        class: "case-item",
        onClick: _cache[7] || (_cache[7] = $event => toCasePage('hinova'))
      }, [_cache[19] || (_cache[19] = _createElementVNode("div", {
        class: "logo-box"
      }, [_createElementVNode("img", {
        src: _imports_7,
        alt: ""
      })], -1)), _createElementVNode("div", _hoisted_49, [_createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.$t('successCase.text64')), 1), _createElementVNode("div", _hoisted_51, [_createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.$t('successCase.text65')), 1), _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.$t('successCase.text66')), 1), _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.$t('successCase.text67')), 1), _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.$t('successCase.text68')), 1)]), _createElementVNode("span", null, _toDisplayString(_ctx.$t('successCase.text69')) + "...... ", 1)])]), _createElementVNode("div", {
        class: "case-item",
        onClick: _cache[8] || (_cache[8] = $event => toCasePage('haooubo'))
      }, [_cache[20] || (_cache[20] = _createElementVNode("div", {
        class: "logo-box"
      }, [_createElementVNode("img", {
        src: _imports_8,
        alt: ""
      })], -1)), _createElementVNode("div", _hoisted_56, [_createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.$t('successCase.text134')), 1), _createElementVNode("div", _hoisted_58, [_createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.$t('successCase.text65')), 1), _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.$t('successCase.text66')), 1)]), _createElementVNode("span", null, _toDisplayString(_ctx.$t('successCase.text135')) + "...... ", 1)])]), _createElementVNode("div", {
        class: "case-item",
        onClick: _cache[9] || (_cache[9] = $event => toCasePage('trustEconomy'))
      }, [_cache[21] || (_cache[21] = _createElementVNode("div", {
        class: "logo-box kuaishou"
      }, [_createElementVNode("img", {
        src: _imports_9,
        alt: ""
      })], -1)), _createElementVNode("div", _hoisted_61, [_createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.$t('successCase.text144')), 1), _createElementVNode("div", _hoisted_63, [_createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.$t('successCase.text61')), 1), _createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.$t('successCase.text136')), 1)]), _createElementVNode("span", null, _toDisplayString(_ctx.$t('successCase.text137')) + "...... ", 1)])]), _createElementVNode("div", {
        class: "case-item",
        onClick: _cache[10] || (_cache[10] = $event => toCasePage('power'))
      }, [_cache[22] || (_cache[22] = _createElementVNode("div", {
        class: "logo-box kuaishou"
      }, [_createElementVNode("img", {
        src: _imports_10,
        alt: ""
      })], -1)), _createElementVNode("div", _hoisted_66, [_createElementVNode("span", _hoisted_67, _toDisplayString(_ctx.$t('successCase.text138')), 1), _createElementVNode("div", _hoisted_68, [_createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.$t('successCase.text61')), 1), _createElementVNode("div", _hoisted_70, _toDisplayString(_ctx.$t('successCase.text139')), 1)]), _createElementVNode("span", null, _toDisplayString(_ctx.$t('successCase.text140')) + "...... ", 1)])]), _createElementVNode("div", {
        class: "case-item",
        onClick: _cache[11] || (_cache[11] = $event => toCasePage('liveEra'))
      }, [_cache[23] || (_cache[23] = _createElementVNode("div", {
        class: "logo-box kuaishou"
      }, [_createElementVNode("img", {
        src: _imports_11,
        alt: ""
      })], -1)), _createElementVNode("div", _hoisted_71, [_createElementVNode("span", _hoisted_72, _toDisplayString(_ctx.$t('successCase.text141')), 1), _createElementVNode("div", _hoisted_73, [_createElementVNode("div", _hoisted_74, _toDisplayString(_ctx.$t('successCase.text61')), 1), _createElementVNode("div", _hoisted_75, _toDisplayString(_ctx.$t('successCase.text142')), 1)]), _createElementVNode("span", null, _toDisplayString(_ctx.$t('successCase.text143')) + "...... ", 1)])])])]), _createElementVNode("div", _hoisted_76, [_createElementVNode("div", _hoisted_77, [_createElementVNode("h3", _hoisted_78, _toDisplayString(_ctx.$t('successCase.text17')), 1), _createElementVNode("span", {
        class: "consult-btn",
        onClick: goAdvisory
      }, _toDisplayString(_ctx.$t('successCase.text18')), 1)])]), _createVNode(_component_AdvisoryService, {
        ref_key: "advisoryServiceRef",
        ref: advisoryServiceRef
      }, null, 512)]);
    };
  }
});